import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

function CuadroTrazador() {
  const { idSolicitud } = useParams();

  const [conteoEncuestas, setConteoEncuestas] = useState(0);
  const [resultados, setResultados] = useState([]);

  // 🔹 Obtener conteo
  useEffect(() => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerConteoEvaluaciones/3/${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((response) => {
        setConteoEncuestas(response.data || 0);
      })
      .catch((error) => console.error("Error obteniendo conteo:", error));
  }, [idSolicitud]);

  // 🔹 Obtener resultados
  useEffect(() => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerResultados/3/${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((response) => {
        setResultados(response.data || []);
      })
      .catch((error) => console.error("Error obteniendo resultados:", error));
  }, [idSolicitud]);

  return (
    <div className="container">
      <div className="text-center">
        <div className="container-fluid">
          <div className="card shadow mb-4">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Información Encuestas
              </h6>
              <p>
                Encuestas realizadas:{" "}
                <strong>{conteoEncuestas || "No hay datos disponibles"}</strong>
              </p>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                <table
                  className="table table-bordered"
                  width="100%"
                  cellSpacing="0"
                >
                  <thead className="thead-light">
                    <tr>
                      <th>Variable</th>
                      <th>% Cumplimiento</th>
                    </tr>
                  </thead>

                  <tbody>
                    {resultados.length > 0 ? (
                      resultados.map(
                        ({ pregunta, suma, respuestasEfectivas }, index) => {
                          // 🔹 Protección contra división por 0
                          const promedio =
                            respuestasEfectivas > 0
                              ? suma / respuestasEfectivas
                              : 0;

                          const porcentaje = ((promedio / 5) * 100).toFixed(0);

                          // 🔹 Colores por rango
                          let colorClass = "";
                          let backgroundColor = "";
                          let textColor = "black";
                          if (porcentaje < 70) {
                            backgroundColor = "#ff6961"; // rojo suave
                            textColor = "white";
                          } else if (porcentaje >= 70 && porcentaje <= 85) {
                            backgroundColor = "#fdfd96"; // amarillo pastel
                          } else {
                            backgroundColor = "#77dd77"; // verde pastel
                            textColor = "white";
                          }

                          return (
                            <tr key={index}>
                              <td className="text-justify">{pregunta}</td>

                              <td className={`${colorClass} font-weight-bold`}>
                                {porcentaje}%
                              </td>
                            </tr>
                          );
                        },
                      )
                    ) : (
                      <tr>
                        <td colSpan="2">No hay resultados disponibles</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CuadroTrazador;
